import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, Container } from 'react-bootstrap';
import SelectTime from './BookingTimeSelection';
import CategorySelection from './BookingCategorySelection';
import CustomerInfo from './BookingCustomerInfo';
import ThankYou from './BookingThankYou';
import SpinnerCard from './SpinnerCard';
import WelcomeCard from './BookingWelcomeCard';
import { getJSONDate } from './CalendarUtil';

function Booking() {

    const { licenseName } = useParams();
    const [license] = useState(licenseName);
    const [customerData, setCustomerData] = useState()
    const [customerVersionOK, setCustomerVersionOK] = useState(true);
    let [shownControl, setShownControl] = useState('category');
    let [bookingSaved, setBookingSaved] = useState(false);
    let [saveStatus, setSaveStatus] = useState();
    let [selectedCategory, setSelectedCategory] = useState();
    let [selectedSlot, setSelectedSlot] = useState();

    useEffect(() => {
        const callApi = async () => {
            const query = `/api/${license}`;
            const res = await fetch(query,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                });
            if (res.status !== 200) {
                setCustomerVersionOK(false);
                setCustomerData({});
            } else {
                const resJson = await res.json();
                setCustomerData(resJson);
            }
        }
        callApi();
    }, [license])

    function onCategoryEdit() {
        setShownControl('category');
    }

    function onCategorySelected(category) {
        setShownControl('time');
        setSelectedCategory(category);
    }

    function onTimeEdit() {
        setShownControl('time');
    }

    function onTimeSelected(slot) {
        setSelectedSlot(slot);
        setShownControl('customer');
    }

    function onBookingSaved(customer) {
        const data = {
            customer: customer,
            category: selectedCategory,
            slot: {
                start: getJSONDate(selectedSlot.start),
                end: getJSONDate(selectedSlot.end)
            },
            settings: customerData.settings
        };
        saveBooking(data)
        setBookingSaved(true);
        setShownControl('thankyou');
    }

    function saveBooking(customer) {
        const callApi = async () => {
            const query = `/api/${license}/booking`;
            const res = await fetch(query,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(customer)
                });
            setSaveStatus(res.status);
        }
        callApi();
    }

    function isLoading() {
        return customerData === undefined;
    }

    if (isLoading()) {
        return (
            <Container className="spinner-card">
                <Row className="justify-content-md-center">
                    <Col xs={12}>
                        <SpinnerCard />
                    </Col>
                </Row>
            </Container>
        );
    } else {
        if (!customerVersionOK) {
            return (
                <div>
                    Du har för gammal version av Agitura Journal för att använda
                    funktionen för onlinebokning.
                </div>
            )
        } else {
            return (
                <Container className="mainContainer" style={{ paddingTop: "20px", marginTop: "50px" }}>
                    <Row className="justify-content-md-center">
                        <Col xs={0}></Col>
                        <Col xs={12}>
                            <WelcomeCard customerData={customerData} />
                            <br />
                            <CategorySelection
                                customerData={customerData}
                                onEdit={onCategoryEdit}
                                bookingSaved={bookingSaved}
                                shownControl={shownControl}
                                onSelect={onCategorySelected}
                            />
                            <br />
                            <SelectTime
                                customerData={customerData}
                                onEdit={onTimeEdit}
                                category={selectedCategory}
                                bookingSaved={bookingSaved}
                                shownControl={shownControl}
                                onSelect={onTimeSelected}
                            />
                            <br />
                            <CustomerInfo onSaved={onBookingSaved} shownControl={shownControl} />
                            <br />
                            <ThankYou saveStatus={saveStatus} customerData={customerData} shownControl={shownControl} />
                        </Col>
                        <Col xs={0}></Col>
                    </Row>
                </Container>
            );
        }
    }

}

export default Booking;